export let Score = (props) => {
  return <div className="Score">Score : {props.score}</div>;
};
